
import { AppBar, Grid, Hidden, Toolbar, Typography } from '@material-ui/core';
import { useContext, useRef } from 'react';
import { AppContext } from '../../../context/context';
import { ButtonRef } from '../../../Interfaces/Interfaces';
import Login from './Login/Login';
import NavMenu from './NavMenu/NavMenu';
import NavTabs from './NavTabs/NavTabs';


const Navbar = () => {
    const logRef = useRef<ButtonRef>(null);
    const { sharedData: { isLogged, username } } = useContext(AppContext);

	return (
        <Grid item xs={12}>
            <AppBar position="sticky">
                <Toolbar>
                    <Grid container justify="space-between"  alignItems="center">
                        <Grid item>
                            <NavMenu />
                            <NavTabs />
                        </Grid>
                        {isLogged &&
                            <Grid item style={{marginLeft:"-25rem"}}>
                                <Hidden only={['xs', 'sm','md']}>
                                    <Typography display="inline" color="inherit" >Welcome </Typography>
                                    <Typography display="inline" color="inherit" >{username}</Typography>
                                </Hidden>
                            </Grid>
                        }
                        <Login logRef={logRef}/>
                    </Grid>
                </Toolbar>
            </AppBar>
        </Grid>
    )
}
export default Navbar ;
